import { render, staticRenderFns } from "./AdvertiserSingle.vue?vue&type=template&id=74e98dcd&scoped=true&"
import script from "./AdvertiserSingle.vue?vue&type=script&lang=ts&"
export * from "./AdvertiserSingle.vue?vue&type=script&lang=ts&"
import style0 from "./AdvertiserSingle.vue?vue&type=style&index=0&id=74e98dcd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e98dcd",
  null
  
)

export default component.exports